<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <el-col :span="12">
        <el-select v-model='uvcId' @change="theuvcIdChange" size="small" clearable placeholder="请选择类型">
          <el-option v-for="item in getUserVisitorClassList_data.data||[]" :key="item.uvcId" :label="item.uvcName"
            :value="item.uvcId">
          </el-option>
        </el-select>
        <el-input v-model="getYcQuestionTopicList_data.qtName" placeholder="请输入试题" clearable size='small'
          style="max-width:200px;" />
        <el-button v-click.getYcQuestionTopicList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
      </el-col>

      <el-col :span="6">
        <el-button @click="dialog = true; edit = false;" size='small' type="primary" style="float:right"
          icon='el-icon-circle-plus'>新增试题
        </el-button>
      </el-col>
    </el-row>

    <mytable :tableColums='tableColums_getYcQuestionTopicList' api='getYcQuestionTopicList' xupdateapi='updateBusiness'
      :height="H-165">
      <div slot="qtSubname" slot-scope="{row}" v-html="row.qtSubname"
        style="max-height: 30vh;overflow: hidden;max-width: 99%;"></div>
      <div slot="itName" slot-scope="{row}" style="max-height: 30vh;overflow: hidden;max-width: 99%;">
        <div v-for="(item, index) in row.ycQuestionTopicItemList" :key="index" v-if="row.qttId == 1">
          <p :style="{ color: item.qtiIsAnswer == 2 ? '#ff5500' : 'black' }">{{ item.qtiValue }}</p>
        </div>
        <span v-if="row.qttId == 2">
          {{row.qtDefaultValue }}
        </span>
      </div>
    </mytable>

    <!-- 新增试题 -->
    <el-dialog :title="edit == true ? '编辑试题' : '新增试题'" :visible.sync="dialog" :before-close="closeSubject">
      <el-form :model="form">
        <el-form-item label="试题名称" prop="qtName" :label-width="formLabelWidth">
          <el-input v-model="form.qtName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="试题分类" :label-width="formLabelWidth"  prop="yvqtcId" >
          <el-select v-model="form.yvqtcId" clearable placeholder="请选择分类" >
            <el-option v-for="(item, index) in getYcVisitorQuestionTopicClassList_data.data || []" :label="item.yvqtcName"
              :value="item.yvqtcId" :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试题排序" :label-width="formLabelWidth">
          <el-input v-model="form.qtOrder" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="试题描述" :label-width="formLabelWidth">

          <quill-editor v-model="form.qtSubname" :options="custom"></quill-editor>
        </el-form-item>
        <!-- <el-form-item label="试题描述颜色" :label-width="formLabelWidth">
          <el-select v-model="form.qtSubnameColor" clearable placeholder="请选择颜色">
            <el-option label="黑色" value="#909399">
            </el-option>
            <el-option label="红色" value="red">
            </el-option>
            <el-option label="蓝色" value="blue">
            </el-option>
            <el-option label="绿色" value="green">
            </el-option>
          </el-select>

        </el-form-item> -->
        <el-form-item label="是否必填" :label-width="formLabelWidth">
          <el-radio-group v-model="form.qtNecessarily">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="试题类型" :label-width="formLabelWidth" prop="qttId" v-if="edit == false">
          <el-select v-model="form.qttId" clearable placeholder="请选择类型" @change="qttIdChange">
            <el-option v-for="(item, index) in getYcQuestionTopicTypeList_data.data || []" :label="item.qttName"
              :value="item.qttId" :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="填空题规则" :label-width="formLabelWidth" v-if="theQttId == 2">
          <el-select v-model="form.stvrId" clearable placeholder="请选择">
            <el-option v-for="(item, index) in getSysTopicValueRuleList_data.data || []" :label="item.stvrDes"
              :value="item.stvrId" :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="填空题非法字符" :label-width="formLabelWidth" v-if="theQttId == 2">
          <el-select v-model="form.stviIds" clearable multiple placeholder="请选择" @change="$forceUpdate()">
            <el-option v-for="(item, index) in getSysTopicValueIllegalList_data.data || []" :label="item.stviValue"
              :value="item.stviId" :key="index">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="theQttId == 1 && edit == false" :label-width="formLabelWidth">
          <div xstyle="border: 1px solid black;">
            <el-button style="margin-left:10px;" type="primary" round size="small" class="el-icon-circle-plus"
              @click="toAddArray">
              添加
            </el-button>
            <el-table :data="array" border highlight-current-row :header-cell-style="{
                          textAlign: 'center',
                          background: 'rgba(0,170,255,0.5)',
                          color: 'black',
                          border: 'none'
                        }" style="width: 100%;margin:12px 0 0 0;">
              <el-table-column type="index" label="单选" align="center" width="80">
                <template slot-scope="scope">
                  <el-radio v-model="currentRowId" :label="scope.row.id" @change="changeRadio($event, scope.row)">
                    &nbsp;</el-radio>
                </template>
              </el-table-column>
              <el-table-column label="内容" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.qtiValue" size="medium" style="padding:7px;"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                  <el-button type="danger" size="small" round class="el-icon-delete"
                    @click="toDeleteArray(scope.$index, scope.row)"> 删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>

        <el-form-item v-if="theQttId == 2" label="填空题预设答案" :label-width="formLabelWidth">
          <div>
            <el-input style="width: 100%;margin-left:0px;" v-model="form.qtDefaultValue" placeholder="请输入答案"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeSubject">取 消</el-button>
        <el-button type="primary" @click="SubmitSubject">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑选项 -->
    <el-dialog title="编辑选项" :visible.sync="DiaOption" width="50%" :before-close="optionClose">
      <div xstyle="border: 1px solid black;" v-if="qttID_option == 1">
        <el-button style="margin-left:10px;" type="primary" round size="small" class="el-icon-circle-plus"
          @click="toAddOption">
          添加
        </el-button>
        <el-table :data="array" border highlight-current-row :header-cell-style="{
              textAlign: 'center',
              background: 'rgba(0,170,255,0.5)',
              color: 'black',
              border: 'none'
            }" style="width: 100%;margin:12px 0 0 0;">
          <el-table-column type="index" label="单选" align="center" width="80">
            <template slot-scope="scope">
              <el-radio v-model="currentRowId" :label="scope.row.id" @change="changeRadio($event, scope.row)">
                &nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="内容" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.qtiValue" size="medium" style="padding:7px;"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="230">
            <template slot-scope="scope">
              <el-button type="danger" size="small" round class="el-icon-delete"
                @click="toDeleteOption(scope.$index, scope.row)"> 删除</el-button>
              <el-button type="success" size="small" round class="el-icon-circle-plus"
                @click="SaveOption(scope.$index, scope.row)"> 保存选项</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>


    </el-dialog>
    <!-- 添加关联 -->
    <el-dialog title="编辑关联" :visible.sync="Relevancy" width="50%" :before-close="RelevancyClose">
      <el-row style="width: 95%;">
        <el-button type="primary" style="margin: 0px 0 10px 85%;" @click="addTopicS">新增关联</el-button>

      </el-row>

      <el-card v-for="(topic, id) in RelevancyArr" :key='id' style="margin: 15px 0;">
        <el-form :model="topic" label-position="top" :rules="rules">
          <el-row style="width: 95%;">
            <el-button type="danger" style="margin: 0px 0 10px 85%;" @click="delTopic(id)">删除关联</el-button>
          </el-row>

          <el-form-item label="关联试题" label-width="100" prop="qtName">
            <el-select v-model="topic.qtName" clearable placeholder="请选择题目" @change="RelevancyChange(id)">
              <el-option v-for="(item, index) in getQuestionTopicList_data" :label="item.qtName" :value="item.qtName"
                :key="index">
              </el-option>
            </el-select>
            <el-select v-model="topic.qtiIds" clearable multiple placeholder="请选择题目选项"
              @change="RelevancyQtiId(topic.qtiIds, id)" style="margin-left: 15px;">
              <el-option v-for="(item, ind) in qtstr[id]" :label="item.qtiValue" :value="item.qtiId" :key="ind">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <el-row style="margin: 15px;">
        <p style="margin: 15px 10px;font-size: 15px;">关联关系</p>
        <el-radio-group v-model="QtiIdsFrom.tirType">
          <el-radio :label="1">或</el-radio>
          <el-radio :label="2">且</el-radio>
        </el-radio-group>
      </el-row>
      <!-- <el-row style="margin: 15px;">
            <p style="margin: 15px 10px;font-size: 15px;">是否必填</p>
            <el-radio-group v-model="QtiIdsFrom.qtNecessarily">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-row> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="RelevancyClose()">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        IsClick:false,
        subJect: [],
        QtiIds: [],
        qtstr: [],
        stviIdArr: [],
        stvrIdarr: [],
        RelevancyArr: [{
          qtName: '',
          qtId: '',
          qtiIds: '',
        }, ], //关联表单
        QtiIdsFrom: {
          qtId: '',
          tirType: 1,
          qtiIds: '',

        },
        DiaOption: false,
        qtid_option: '',
        qttID_option: '',
        rules: {
          qtName: [{
            required: true,
            message: '请输入题目名称',
            trigger: 'blur'
          }],
          qttId: [{
            required: true,
            message: '请选择分类',
            trigger: 'change'
          }],
        },
        Relevancy: false,
        totals: null, // 总数
        theSearchQttId: '', // 单选题  多选题  判断题  填空题  简答题
        theAnswer: '', // 填空,简答的答案
        currentRowId: 1,
        currentRowIdMulti: 1,
        array: [{
          qtiValue: 'A.',
          qtiIsAnswer: 1,
          id: 1
        }],
        theQttId: '',
        formLabelWidth: '180px',

        dialog: false,
        edit: false,
        form: {
          qtName: '',
          qttId: '',
          yvqtcId:'',
          ypId: '',
          stvrId: '',
          qtNecessarily: '',
          qtOrder: '',
          qtSubname: '',
          qtSubnameColor: '',
          qtDefaultValue: '',
          stviIds: '',
          questionTopicItemListString: ''
        },
        custom: { //配置富文本工具栏
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
              // ['blockquote', 'code-block'],                      //引用，代码块
              // [{ 'header': 1 }, { 'header': 2 }],               // 几级标题
              // [{ 'list': 'ordered'}, { 'list': 'bullet' }],     // 有序列表，无序列表
              [{
                'script': 'sub'
              }, {
                'script': 'super'
              }], // 下角标，上角标
              // [{ 'indent': '-1'}, { 'indent': '+1' }],          // 缩进
              // [{ 'direction': 'rtl' }],                         // 文字输入方向
              // [{ 'size': ['45px','60px','90px'] }],  // 字体大小
              // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],// 标题
              [{
                'color': []
              }, {
                'background': []
              }], // 颜色选择
              // [{ 'font': ['SimSun', 'SimHei','Microsoft-YaHei','KaiTi','FangSong','Arial'] }],// 字体
              [{
                'align': []
              }], // 居中
              // ['clean']                                         // 清除样式
            ]
          }
        },
        uvcId: null, //项目拜访分类id
        projectId: null,
        tableColums_getYcQuestionTopicList: {
          $selection: false,
          qtName: '试题名称',
          yvqtcName: '试题分类',
          qttName: '试题类型',
          qtNecessarily: ['是否必填', , '@v-if: 1:必填#success, 2:不是#danger'],
          qtOrder: '试题排序',
          qtSubname: ['试题描述', '@v-html'],
          qtSubnameColor: '试题颜色',
          itName: ['试题选项',250],
          topicItemRelationDes: ['关联关系',300],
          createtime: ['创建时间',180],
          $operation: this.deleteProjectBusiness && [
            '操作', 250,

            `@text: 删除#danger
           
            @click: _confirm('确定要删除吗?')
                   .trigger('deleteYcQuestionTopic',{qtId:$row.qtId})
                   .trigger('getYcQuestionTopicList',{uvcId})
          `,
            `@text: 编辑#success
            @click:EditSubject($row)
          `,
            `@text: 编辑选项#success
            @click:editOption($row)
          `,
            `@text: 添加关联#primary
            @click:addRelevancy($row)
          `,
          ],
        },


      };
    },

    watch: {

    },

    methods: {
      // 添加关联
      RelevancyQtiId(data, ind) {
        //console.error(data)
        //console.error(ind)
        this.QtiIds.splice(ind, 1, data);
      },
      async addRelevancy(row) {
        this.QtiIdsFrom.qtId = row.qtId
        const s = {
          uvcId: this.uvcId,
          qttId: 1
        }
        await this.getYcQuestionTopicLists(s).result(res => {
          this.getQuestionTopicList_data = res.data.data;
          this.getQuestionTopicList_data.forEach((item, index) => {
            if (row.qtId == item.qtId) {
              this.getQuestionTopicList_data.splice(index, 1)
            }
          })
        })
        // 是否之前添加过关联
        const s_s = {
          qtId: row.qtId
        }
        this.$nextTick(async () => {
          this.getYcQuestionTopicRelation(s_s).result(res => {
            this.subJect = res.data.data
            if (this.subJect.questionTopicList.length > 0) {
              console.log('11111', this.subJect)
              this.subJect.questionTopicList.forEach((item, ind) => {
                this.RelevancyArr.splice(ind, 1, {
                  qtName: item.qtName,
                  qtId: item.qtId,
                  qtiIds: item.itemIds
                })
                console.log(this.RelevancyArr)
                this.qtstr.splice(ind, 1, item.ycQuestionTopicItemList);
                this.QtiIds.splice(ind, 1, item.itemIds);
                this.QtiIdsFrom.tirType = this.subJect.tirType;
              })
            }
          })
        })
        this.Relevancy = true;
      },
      async submit() {
        var ids = [];
        this.QtiIds.forEach((item, ind) => {
          item.forEach((itm, it) => {
            ids.push(itm)
          })
        })

        this.QtiIdsFrom.qtiIds = ids.toString()
        await this.updateYcQuestionTopicRelation(this.QtiIdsFrom).result(res => {
          this.Relevancy = false;
          this.tableList();
          this.RelevancyArr = [{
            qtName: '',
            qtId: '',
            qtiIds: '',
            qtNecessarily: ''
          }, ]; //关联表单

          this.QtiIdsFrom = {
            qtId: '',
            tirType: 1,
            qtiIds: '',
            qtNecessarily: ''
          };
          this.$message({
            type: 'success',
            message: '添加关联成功!'
          })
        })

      },
      async RelevancyChange(ind) {

        const s = {
          qtName: this.RelevancyArr[ind].qtName,
          uvcId: this.uvcId
        }
        await this.getYcQuestionTopicOne(s).result(res => {
          this.RelevancyArr[ind].qtId = res.data.data.qtId;
          this.qtstr.splice(ind, 0, res.data.data.ycQuestionTopicItemList);
          this.RelevancyArr[ind].qtiIds = []
        })

      },
      delTopic(index) {
        this.RelevancyArr.splice(index, 1);
        this.QtiIds.splice(index, 1)


      },
      addTopicS() {
        this.RelevancyArr.push({
          qtName: '',
          qtId: '',
          qtiIds: '',
        })
      },
      RelevancyClose() {
        this.Relevancy = false;
        this.RelevancyArr = [{
            qtName: '',
            qtId: '',
            qtiIds: '',
          }, ], //关联表单
          this.QtiIdsFrom = {
            qtId: '',
            tirType: 1,
            qtiIds: '',
            qtNecessarily: ''
          },
          this.tableList();

      },
      optionClose() {
        this.DiaOption = false,
          this.array = [];
        this.theAnswer = ''
        this.tableList()
      },
      async SaveOption(index, row) {

        await this.updateYcQuestionTopicItem(row)
        this.$message({
          type: 'success',
          message: '保存成功!'
        })
      },
      async toDeleteOption(index, row) {


        await this.deleteYcQuestionTopicItem({
          qtiId: row.qtiId
        })
        this.array.splice(index, 1)
      },

      // 编辑选项
      async toAddOption() {



        await this.addYcQuestionTopicItem({
          qtId: this.qtid_option
        }).result(ss => {
          this.array.push({
            qtiId: ss.data.data.qtiId,
            qtiValue: '',
            qtiIsAnswer: 1,
            id: this.array.length + 1
          })
        })
        //console.log(data)

      },

      editOption(val) {
        this.DiaOption = true;
        const data = JSON.parse(JSON.stringify(val))
        this.qtid_option = data.qtId;
        if (data.qttId == 1) {
          // console.log(array)
          this.qttID_option = data.qttId
          console.log(val)
          this.array = val.ycQuestionTopicItemList
          console.log(this.array)
          // 设置选中
          this.array.forEach((element, index) => {
            element.id = index + 1
            if (element.qtiIsAnswer == 2) {
              element.qtiIsAnswer = 2
              this.currentRowId = element.id
            }
          })
        }

      },

      closeSubject() {
        this.form = {
          yvqtcId:'',
          stviIds: '',
          stvrId: '',
          qtName: '',
          qttId: '',
          qtNecessarily: '',
          questionTopicItemListString: '',
          qtOrder: '',
          qtSubname: '',
          qtSubnameColor: '',
          qtDefaultValue: '',
        };
        this.theQttId = '';
        this.dialog = false;
        this.edit = false;
      },
      EditSubject(val) {
        this.edit = true
        this.dialog = true
        const data = JSON.parse(JSON.stringify(val))
        this.form = data;
        this.form.stvrId = data.stvrId *1
        this.form.stviIds = data.stviIdList
        this.form.qtId = data.qtId
        this.form.qtName = data.qtName
        this.form.qttId = data.qttId
        this.form.qtNecessarily = data.qtNecessarily
        this.theQttId = val.qttId;
        console.log(this.form)

        // switch (this.theQttId) {
        //   case 1:
        //     break

        //   case 2:
        //     break
        //   case 3:

        //   case 4:

        // }


      },
      SubmitSubject() {
        if (!this.edit) {
          this.$confirm('是否确认新增, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            switch (this.theQttId) {
              case 1:

                this.array.forEach(element => {
                  if (element.id == this.currentRowId) {
                    element.qtiIsAnswer = 2
                  }
                  if (element.qtiValue == null || element.qtiValue == '') {
                    this.$message({
                      message: '选项不能为空',
                      type: 'warning'
                    })
                  }
                })
                break
              case 2:

              case 3:
              case 4:
            }
            this.form.uvcId = this.uvcId;
            this.form.questionTopicItemListString = JSON.stringify(this.array)
            this.form.stviIds = this.form.stviIds.toString();
            console.log(this.form.stviIds)
            this.addYcQuestionTopic(this.form).result(res => {
              if (!res.data) return
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success'
              })
              this.getYcQuestionTopicList({
                uvcId: this.uvcId
              });
              this.form = {
                yvqtcId:'',
                stviIds: '',
                stvrId: '',
                qtName: '',
                qttId: '',
                qtNecessarily: '',
                questionTopicItemListString: '',
                qtOrder: '',
                qtSubname: '',
                qtSubnameColor: '',
                qtDefaultValue: '',
              };
              this.theQttId = '';
              this.dialog = false;
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
        }else{
          this.$confirm('是否确认编辑, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            switch (this.theQttId) {
              case 1:

                this.array.forEach(element => {
                  if (element.id == this.currentRowId) {
                    element.qtiIsAnswer = 2
                  }
                  if (element.qtiValue == null || element.qtiValue == '') {
                    this.$message({
                      message: '选项不能为空',
                      type: 'warning'
                    })
                  }
                })
                break
              case 2:

              case 3:
              case 4:
            }
            this.form.uvcId = this.uvcId;


            this.updateYcQuestionTopic(this.form).result(res => {
              if (!res.data) return
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success'
              })
              this.getYcQuestionTopicList({
                uvcId: this.uvcId
              });
              this.form = {
                yvqtcId:'',
                stviIds: '',
                stvrId: '',
                qtName: '',
                qttId: '',
                qtNecessarily: '',
                questionTopicItemListString: '',
                qtOrder: '',
                qtSubname: '',
                qtSubnameColor: '',
                qtDefaultValue: '',
              };
              this.theQttId = '';
              this.dialog = false;
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
        }

      },
      // 删除选项
      toDeleteArray(index, row) {
        if (this.array.length == 1) {
          return
        }
        this.array.splice(index, 1)
      },
      changeRadio(event, row) {
        this.currentRowId = event
      },
      toAddArray() {

        this.array.push({
          qtiValue: '',
          qtiIsAnswer: 1,
          id: this.array.length + 1
        })
      },
      async qttIdChange(e) {
        if (e == 2) {
          await this.getSysTopicValueRuleList()
        }
        this.array = [{
            qtiValue: 'A.',
            qtiIsAnswer: 1,
            id: 1
          }],
          //console.log(this.array)
          this.theQttId = ''
        await this.$nextTick()
        this.theQttId = e

      },


      theuvcIdChange(e) {
        this.uvcId = e;
        this.getYcQuestionTopicList({
          uvcId: this.uvcId
        });
      },
      myformAddProjectBusiness(submit, Myformdata) {
        Myformdata.projectId = A.local('$projectId');
        submit();
      },
      tableList() {
        this.getYcQuestionTopicList({
          uvcId: this.uvcId
        });
      },
    },

    async created() {
      this.projectId = A.local('$projectId')
      // 自定义类型
      this.getUserVisitorClassList().result(res =>{
        if(res.data.data){
          this.uvcId = res.data.data[0].uvcId;
          this.tableList()
        }
      })
      // 题目类型
      this.getYcQuestionTopicTypeList()
      // 填空题非法字符串
      this.getSysTopicValueIllegalList()
      // 填空题规则
      this.getSysTopicValueRuleList()
      this.getYcVisitorQuestionTopicClassList();
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bussiness/BaifangSubject.vue